var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "flex" }, [
    _c(
      "div",
      {
        staticClass:
          "fixed top-18 z-30 w-88 flex-shrink-0 border-r border-slate-400 bg-pure-white"
      },
      [
        _c(
          "div",
          { staticClass: "p-6 border-b border-slate-400 flex flex-col gap-3" },
          [
            _c(
              "div",
              [
                _c("BlTextTitle3", {
                  attrs: { text: "Client Acquisition Board" }
                })
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "flex p-1 bg-slate-400",
                style: { borderRadius: "8px", height: "2.375rem" }
              },
              _vm._l(_vm.previewTypeOptions, function(opt) {
                return _c(
                  "div",
                  {
                    key: opt.value,
                    staticClass:
                      "rounded flex items-center justify-center gap-1 h-full cursor-pointer w-full transition-all duration-300",
                    class:
                      _vm.previewTypeInput === opt.value
                        ? "bg-pure-white"
                        : "bg-slate-400",
                    on: {
                      click: function($event) {
                        return _vm.onChangePreviewType(opt.value)
                      }
                    }
                  },
                  [
                    opt.value === "kanban"
                      ? _c("BlIcon", {
                          staticClass: "w-4 h-4",
                          attrs: { icon: "kanban", color: "slate-6" }
                        })
                      : _vm._e(),
                    _vm._v(" "),
                    opt.value === "list"
                      ? _c("BlIcon", {
                          staticClass: "w-4 h-4",
                          attrs: { icon: "list", color: "slate-6" }
                        })
                      : _vm._e(),
                    _vm._v(" "),
                    _c("BlTextSubtitle3", { attrs: { text: opt.label } })
                  ],
                  1
                )
              }),
              0
            )
          ]
        ),
        _vm._v(" "),
        _vm.panelLoading
          ? _c("div", {
              staticClass: "w-full grid place-items-center",
              style: { height: "calc(100vh - 15.5rem)" }
            })
          : _c(
              "div",
              {
                staticClass: "overflow-y-auto px-3 py-5",
                style: { height: "calc(100vh - 15.5rem)" }
              },
              [
                _c(
                  "div",
                  {
                    staticClass: "flex items-center justify-between px-3 mb-3"
                  },
                  [
                    _c("BlTextSubtitle3", {
                      staticClass: "text-slate-600",
                      attrs: { text: "Your upcoming to-dos" }
                    }),
                    _vm._v(" "),
                    _c("BlBubbleCount", {
                      attrs: {
                        count: _vm.currentUser.upcoming_todos.length || 0
                      }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                !_vm.currentUser.upcoming_todos.length
                  ? _c(
                      "div",
                      { staticClass: "h-128 grid items-center justify-center" },
                      [
                        _c("BlTextBody2", {
                          attrs: { text: "There are no upcoming to-dos." }
                        })
                      ],
                      1
                    )
                  : _c(
                      "div",
                      { staticClass: "px-3 flex flex-col" },
                      _vm._l(_vm.currentUser.upcoming_todos, function(
                        instruction,
                        idx
                      ) {
                        return _c(
                          "div",
                          { key: instruction.id },
                          [
                            _c("UpcomingTodo", {
                              attrs: { instruction: instruction }
                            }),
                            _vm._v(" "),
                            idx + 1 < _vm.currentUser.upcoming_todos.length
                              ? _c("div", {
                                  staticClass:
                                    "h-0.5 w-full rounded bg-slate-300"
                                })
                              : _vm._e()
                          ],
                          1
                        )
                      }),
                      0
                    )
              ]
            )
      ]
    ),
    _vm._v(" "),
    _vm.previewTypeInput
      ? _c(
          "div",
          { staticClass: "pl-88 bg-slate-100" },
          [
            _vm.previewTypeInput === "kanban" ? _c("PipelineKanban") : _vm._e(),
            _vm._v(" "),
            _vm.previewTypeInput === "list" ? _c("ProspectTable") : _vm._e()
          ],
          1
        )
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-e6ee0f7e", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-e6ee0f7e","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/salesPipeline/ClientAcquisition.vue
// module id = null
// module chunks = 